<template>
  <div class="my-bannar">
    <div class="left"></div>
    <div class="main">
      <div class="bannar-list">
        <div
          class="bannar-item"
          v-for="(item, index) in bannarList"
          :key="item.id"
          @click="handleBannar(item, index)"
          :class="index == bannarIndex ? 'bannar-item-hover' : ''"
        >
          <div style="margin-bottom:6px">{{ item.name }}</div>
          <div class="hover-item" :style="{ 'border-bottom': index == bannarIndex ? '2px solid #FFFFFF' : '' }"></div>
        </div>
      </div>
    </div>
    <div class="right"></div>
    <div class="my-login">
      <Login :isDaoba="false" />
    </div>
  </div>
</template>

<script>
import Login from '@comm/components/LoginTag.vue'
export default {
  components: {
    Login,
  },
  data() {
    return {
      bannarIndex: 0,
      bannarList: [
        {
          id: 1,
          name: '首页',
          path: '/',
        },
        {
          id: 2,
          name: '竞赛项目',
          path: '/project',
        },
        {
          id: 3,
          name: '奖牌榜',
          path: '/schedule',
        },
        {
          id: 4,
          name: '代表团',
          path: '/delegation',
        },
        {
          id: 5,
          name: '场馆指南',
          path: '/stadium',
        },
        {
          id: 6,
          name: '最美九龙坡',
          path: '/beautifulJiulong',
        },
      ],
    }
  },
  mounted() {
    this.hanldeMenu()
  },
  methods: {
    handleBannar(item, index) {
      this.bannarIndex = index
      this.$router.push(item.path)
      localStorage.setItem('menuIndex', index)
    },
    hanldeMenu() {
      this.bannarIndex = this.$route.meta.menuIndex ? this.$route.meta.menuIndex : localStorage.getItem('menuIndex')
      if (this.$route.path == '/') {
        this.bannarIndex = 0
      }
    },
  },
  watch: {
    $route(newValue, oldValue) {
      this.hanldeMenu()
    },
  },
}
</script>

<style lang="scss" scoped>
.my-bannar {
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  box-sizing: border-box;
  margin-top: -100px;
  opacity: 1;
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
  z-index: 999;
  position: relative;

  .left {
    width: 0;
    height: 0;
    border-right: 0 solid transparent;
    border-bottom: 100px solid #124584;
    border-left: 50px solid transparent;
    border-top: 0 solid transparent;
    box-sizing: border-box;
  }

  .main {
    width: 100%;
    height: 100%;
    background-color: #124584;
    box-sizing: border-box;
  }

  .right {
    width: 0;
    height: 0;
    border-right: 0 solid transparent;
    border-top: 100px solid #124584;
    border-right: 50px solid transparent;
    box-sizing: border-box;
  }
  .bannar-list {
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: flex-start;
    height: 100px;
    align-items: center;
    box-sizing: border-box;
    padding: 20px 0;
    padding: 0 30px;
    .bannar-item {
      cursor: pointer;
      margin-right: 80px;
    }
    .hover-item {
      width: 100%;
      height: 2px;
      border-bottom: 2px solid #124584;
      // margin-bottom: 5px;
    }
  }
  .my-login {
    height: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-18%);
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/district/components/common/Bannar.vue